<script>
import { mapGetters, mapActions } from "vuex";
import { getProducts, getAreas } from "@/api/static";
import CC from "@/api/config-center";
import { encrypt } from "@/vendor/crypto";

export default {
  computed: {
    ...mapGetters({
      areaAssignment: "order/areaAssignment",
      isPopState: "order/isPopState",
      campaign: "event/campaign",
      session: "session/sessionInfo"
    }),
    isInPostLimit() {
      const end = new Date(this.session.sessionEnd).valueOf();
      const dt = new Date().valueOf();
      return this.campaign.pickUp.includes("post") && end - 86400000 * 9 > dt;
    }
  },
  data() {
    return {
      tickets: [],
      seatAreas: [],
      loadingData: true
    };
  },
  methods: {
    ...mapActions({
      setTicketProduct: "session/setTicketProduct"
    }),
    async setInfo(refresh = false) {
      const productId = this.tickets.map((p) => String(p.productId));

      const [{ data: resInfo }, getInfosErr] = await CC.getInfos(
        this.session.ticketArea
          ? {
            ticketAreaId: this.seatAreas.map((a) => a.ticketAreaId),
            productId
          }
          : { productId },
        refresh
      );

      if (resInfo && resInfo.errCode === "00") {
        if (resInfo.result.ticketArea) {
          this.setSeatArea(resInfo.result.ticketArea);
        }
        this.getProductCount(resInfo.result.product);
      }
    },
    async setSeatArea(areas) {
      this.seatAreas = this.seatAreas.reduce((accr, a, i) => {
        const area = areas.find((res) => res.id === a.ticketAreaId);

        if (!area.hidden) {
          accr.push({
            ...a,
            ...area,
            price: Number(a.price),
            count: area.status === "unavailable" ? 0 : area.count
          });
        }
        return accr;
      }, []);

      if (this.currentArea) {
        this.currentArea = this.seatAreas.find(
          (s) => s.id === this.currentArea.id
        );
      }
    },
    async getProductCount(products) {
      this.tickets = this.tickets.reduce((accr, s) => {
        const product = products.find((res_s) => res_s.id === s.productId);

        accr.push({
          ...s,
          ...product,
          userLimit: product.userLimit,
          limit: product.purchaseLimit || product.count || 0,
          remain: product.status === "lock" ? 0 : product.count || null,
          status: product.status,
          hidden: product.hidden,
          unit: product.unit,
          sortedIndex: product.sortedIndex,
          ccDiscount: product.ccDiscount || [],
          coupon: product.coupon || [],
          ticketAreaId: product.ticketAreaId || null,
          loadingStatusFinished: true,
          count: window.isEnquene ? s.count : 0
        });

        return accr;
      }, []);

      this.$forceUpdate();

      this.tickets = this.tickets.filter(
        (t) => t.remain !== undefined && !t.hidden
      );
      if (this.session.groupBy) {
        await this.groupArea();
      }
      this.loadingData = false;
    },
    async productInit(reset) {
      if (this.tickets.length && !reset) return;

      if (this.session.ticketArea) {
        const { data: areaData } = await getAreas(this.$route.params.eventId);
        const ticketAreas = Array.isArray(areaData.ticketAreas)
          ? areaData.ticketAreas
          : [];
        const sortedAreas = ticketAreas.sort(
          (a, b) => a.sortedIndex - b.sortedIndex
        );
        this.seatAreas = sortedAreas.filter(({ sessionId }) => {
          const sid = /^s[0-9]{9}$/.test(sessionId)
            ? encrypt(sessionId)
            : sessionId;
          return sid === this.$route.params.sessionId;
        });
      }
      const { data: prodData } = await getProducts(this.$route.params.eventId);
      const productList = Array.isArray(prodData.products)
        ? prodData.products
        : [];
      const sortedProducts = productList.sort(
        (a, b) => a.sortedIndex - b.sortedIndex
      );
      const products = sortedProducts.filter(({ sessionId }) => {
        const sid = /^s[0-9]{9}$/.test(sessionId)
          ? encrypt(sessionId)
          : sessionId;
        return sid == this.$route.params.sessionId;
      });

      this.tickets = (window.isEnquene ? this.tickets : products).map((s) => {
        if (!window.isEnquene) {
          s.price = Number(s.price);
          s.remain = s.count;
        } else {
          const prod = products.find((p) => p.productId === s.id);
          s.remain = prod ? prod.count : s.remain;
        }
        return s;
      });
      this.setTicketProduct({ products, tickets: this.tickets });
      await this.setInfo(reset);

      if (reset) {
        if (!window.isEnquene) {
          this.hasSelect = false;
          this.totalTicket = 0;
        }
        this.updateTicket();
      }
      // await this.getProductCount();
      this.$forceUpdate();
    },
    groupArea() {
      this.group = this.seatAreas.reduce((a, area) => {
        if (a.indexOf(area.price) === -1) {
          a.push(area.price);
          a.sort((a, b) => b - a);
        }
        return a;
      }, []);
      this.groupPanel = [...this.group.keys()].map((k, i) => i);
    },
    async resetSelect(reset = false) {
      const resetBool = reset;
      this.panelActive = false;
      this.tickets = this.tickets.map((s) => {
        if (s.count > 0 && !!this.currentArea) { this.currentArea.count += s.count; }
        s.remain += s.count;
        s.count = 0;
        return s;
      });
      if (this.currentArea) {
        this.seatAreas = this.seatAreas.map((area) => {
          return area.id === this.currentArea.id ? this.currentArea : area;
        });
      }

      if (!window.isEnquene) this.currentArea = null;
      this.totalTicket = this.tickets.reduce((accr, t) => {
        accr += t.count;
        return accr;
      }, 0);
      this.panel = [];
      this.productInit(resetBool);
    },
    selStActive(i, area) {
      this.resetSelect();
      this.currentArea = area;
      this.panelActive = true;
    },
    clearSelect() {
      this.resetSelect();
      this.hasSelect = false;
    },
    canLess(index, id) {
      const ticket = this.tickets[index];
      return (
        (!ticket.productLimit || (ticket.productLimit && ticket.limit)) &&
        ticket.count > 0
      );
    },
    canAdd(index, id) {
      const ticket = this.tickets[index];

      return (
        (!ticket.purchaseLimit ||
          (!!ticket.purchaseLimit && ticket.purchaseLimit > ticket.count)) &&
        (!ticket.productLimit ||
          (ticket.productLimit && ticket.limit > ticket.count)) &&
        (!this.session.orderLimit ||
          (!!this.session.orderLimit &&
            this.session.orderLimit > this.totalTicket)) &&
        (this.campaign.pickUp.includes("none") ||
          (!this.campaign.pickUp.includes("none") &&
            (this.isInPostLimit ||
              (!this.isInPostLimit && this.totalTicket < 4))))
      );
    },
    minusCount(index, id) {
      if (this.canLess(index, id)) {
        this.hasSerial = false;
        const unit = this.tickets[index].unit || 1;
        this.tickets[index].count -= unit;
        this.totalTicket -= unit;

        if (!this.tickets.find((t) => t.count && !!t.serialKey)) {
          this.hasSerial = false;
        }
        if (this.totalTicket === 0) {
          this.hasSelect = false;
        }

        if (this.session.ticketArea) {
          if (this.currentArea && this.currentArea.ticketAreaLimit) {
            this.currentArea.count += unit;
          }
          if (this.tickets[index].productLimit) { this.tickets[index].remain += unit; }
        }
        if (!this.session.ticketArea) this.tickets[index].remain += unit;

        this.updateTicket();
      }
    },
    addCount(index, id) {
      if (this.canAdd(index, id)) {
        const unit = this.tickets[index].unit || 1;
        this.hasSelect = true;
        this.tickets[index].count += unit;
        this.totalTicket += unit;

        if (this.tickets.filter((t) => t.count && !!t.serialKey).length) {
          this.hasSerial = true;
        }

        if (this.session.ticketArea) {
          if (this.currentArea && this.currentArea.ticketAreaLimit) {
            this.currentArea.count -= unit;
          }
          if (this.tickets[index].productLimit) { this.tickets[index].remain -= unit; }
        }
        if (!this.session.ticketArea && this.tickets[index].remain > 0) { this.tickets[index].remain -= unit; }

        this.updateTicket();
      }
    },
    formatDateString(date) {
      const dt = new Date(date);
      return `${dt.getFullYear()}/${this.pad(dt.getMonth() + 1, 2)}/${this.pad(
        dt.getDate(),
        2
      )} ${this.pad(dt.getHours(), 2)}:${this.pad(dt.getMinutes(), 2)}`;
    },
    pad(n, width, z) {
      z = z || "0";
      n = n + "";
      return n.length >= width
        ? n
        : new Array(width - n.length + 1).join(z) + n;
    },
    isOverSaleEndTime(date) {
      const today = new Date();
      const end = new Date(date);
      return today.valueOf() > end.valueOf();
    },
    updateTicket() {
      this.$emit("update", {
        selectedTickets: this.tickets.filter((t) => t.count > 0),
        totalTicket: this.totalTicket,
        seatAssignmentInProd: this.seatAssignmentInProd,
        selectedArea: this.session.ticketArea ? this.currentArea : null
      });
    }
  }
};
</script>
